import React, { useEffect, useMemo, useState } from 'react';
import { ReactComponent as PayPalLogo } from '../svg/filled/paypal.svg';
import { connect } from 'react-redux';
import { checkout, initializeCheckoutSession } from '../redux/actions/checkout';
import {
    checkoutLoading,
    pageLoading,
    pagesClientSecretListSelector,
} from '../redux/selectors/pagesSelectors';
import {
    carSelectedCustomBills,
    cartMainProduct,
    cartRenewSelector
} from '../redux/selectors/cartSelector'
import { PAYMENT_PAYPAL_ENABLED } from '../constants/constants';
import { setProceedToCheckoutAfterAuth } from '../redux/actions/pagesActions';
import useTotalNumber from '../hooks/useTotalNumber';
import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_PUBLIC_KEY } from '../general/config';
import { toast } from 'react-toastify'
import { authEmailSelector } from '../redux/selectors/authSelectors'
import StripeSection from './Payment/StripeSection'

function Cards({
    checkout,
    checkoutLoading,
    cartRenew,
    setAccountFormIsVisible,
    setProceedToCheckoutAfterAuth,
    initializeCheckout,
    clientSecretList,
    pageLoading,
    carSelectedCustomBills,
    email,
    cartMainProduct,
}) {
    let totalNumber = useTotalNumber();

    if (Object.keys(carSelectedCustomBills ?? {}).length > 0) {
        totalNumber = carSelectedCustomBills.cost;
    }

    const pagesClientSecret = useMemo(() => {
        if (!clientSecretList?.length || !totalNumber || !email) {
            return null;
        } else {
            const cartRenewText = cartRenew || false;
            return clientSecretList.find(
                (item) => item.key === totalNumber + cartRenewText.toString()
            )?.clientSecret;
        }
    }, [clientSecretList, totalNumber, email, cartRenew, pageLoading, cartMainProduct]);

    const [stripeLoad, setStripeLoad] = useState({ error: null });

    const isPagesClientSecretMissing = !pagesClientSecret;

    useEffect(() => {

        if (totalNumber && email) {
            if (clientSecretList && !pagesClientSecret) {
                initializeCheckout(totalNumber).then(res => {
                    setStripeLoad(prev => {
                        return (prev.error === res.error) ? prev : { error: res.error };
                    });
                });
            }
        }
    }, [totalNumber, clientSecretList, isPagesClientSecretMissing, email, cartRenew, initializeCheckout, pagesClientSecret, cartMainProduct]);

    useEffect(() => {
        if (stripeLoad.error) {
            toast.dismiss();
            toast.error("Something went wrong " + (stripeLoad?.provider ?? ''));
        }
    }, [stripeLoad])

    const [stripe, setStripe] = useState(null);

    useEffect(() => {
        if (!stripe) {
            const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);
            stripePromise.then(setStripe);
        }
    }, [stripe]);

    const handleStripe = () => {
        // TODO пересмотреть эту логику при работе над задачей https://doboard.com/1/task/23234
        if (email) {
            checkout('stripe');
        } else {
            setAccountFormIsVisible(true);
            setProceedToCheckoutAfterAuth('stripe');
        }
    };

    const handlePayPal = () => {
        if (email) {
            checkout('paypal');
        } else {
            setAccountFormIsVisible(true);
            setProceedToCheckoutAfterAuth('paypal');
        }
    };

    useEffect(() => {
        const oldFrame = document.querySelector('iframe[src*="checkout.stripe.com"]');
        if (oldFrame && pagesClientSecret) oldFrame.remove();
    }, [pagesClientSecret]);

    const checkoutTitleStripe = cartRenew
        ? 'Make a payment or subscribe to the service using a credit/debit card'
        : 'Make a one time credit/debit card payment';

    const checkoutTitlePayPal = cartRenew
        ? 'Make a payment or subscribe to the service using PayPal'
        : 'Make a one time PayPal payment';

    return (
        <>
            <div className={'card__main'}>

                <StripeSection
                    stripe={stripe}
                    stripeLoad={stripeLoad}
                    handleStripe={handleStripe}
                    checkoutTitleStripe={checkoutTitleStripe}
                    pagesClientSecret={pagesClientSecret}
                />

                <div className={'card__or'}>OR</div>
                <div className={`card__list card__list${PAYMENT_PAYPAL_ENABLED ? '' : '--single'}`}>
                    {!!PAYMENT_PAYPAL_ENABLED && (
                        <div className={'card__container'}>
                            <div className={''}>
                                <h3 className={'card__title'}>{checkoutTitlePayPal}</h3>
                                <span className={'card__description'}>
                                    It may take up to 5 minutes for the payment process
                                </span>
                            </div>
                            <div className={'card__item'}>
                                <PayPalLogo className={'card__logo'} />
                            </div>
                            <div className={'card__item'}>
                                <button
                                    disabled={checkoutLoading}
                                    onClick={() => handlePayPal()}
                                    type={'button'}
                                    className={'button card__button button--proceed'}
                                >
                                    <span className={'text-2 bold'}>Pay Now</span>
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className={'notification__message mb-60 mt-0'}>
                If you are not 100% satisfied with your purchase, within 60 days from the purchase
                date, we will fully refund the cost of your order.
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    cartMainProduct: cartMainProduct(state),
    checkoutLoading: checkoutLoading(state),
    pageLoading: pageLoading(state),
    cartRenew: cartRenewSelector(state),
    clientSecretList: pagesClientSecretListSelector(state),
    carSelectedCustomBills: carSelectedCustomBills(state),
    email: authEmailSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    checkout: (provider) => dispatch(checkout(provider)),
    setProceedToCheckoutAfterAuth: (provider) => dispatch(setProceedToCheckoutAfterAuth(provider)),
    initializeCheckout: (totalNumber) => dispatch(initializeCheckoutSession(totalNumber)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Cards);
